import { getAdminTabs } from './admin';
import { getTenantAdminTabs, getTenantAdminCategoryOrder } from './tenant-admin';
import { getItServiceTabs, getItServiceCategoryOrder } from './it-service';
import { getEntryTabs } from './entry';
import type { SidebarTab } from '@shared/ui/layout';
import type { User } from '@shared/types';
import type { TFunction } from 'i18next';

interface SidebarConfig {
  serviceName: string;
  serviceHref: string;
  tabs: SidebarTab[];
  categoryOrder?: string[];
  expandedWidthRem?: number;
  headerIconSlug?: string;
}

export function getSidebarConfig(
  pathname: string,
  user: User | null | undefined,
  tAdmin: TFunction<'adminNav'>,
  locale = 'ko',
): SidebarConfig | null {
  if (pathname.startsWith('/admin')) {
    return { serviceName: 'Portal System Admin', serviceHref: '/admin', tabs: getAdminTabs(tAdmin) };
  }
  if (pathname.startsWith('/tenant-admin')) {
    return {
      serviceName: locale === 'en' ? 'Admin Service' : 'ADMIN SERVICE',
      serviceHref: '/tenant-admin',
      tabs: getTenantAdminTabs(locale),
      categoryOrder: getTenantAdminCategoryOrder(locale),
      expandedWidthRem: 18,
      headerIconSlug: 'tnad-hero',
    };
  }
  if (pathname.startsWith('/it-service')) {
    return {
      serviceName: locale === 'en' ? 'IT Service' : 'IT 서비스',
      serviceHref: '/it-service',
      tabs: getItServiceTabs(locale),
      categoryOrder: getItServiceCategoryOrder(locale),
      expandedWidthRem: 18,
      headerIconSlug: 'itsm-hero',
    };
  }
  if (pathname === '/entry') {
    if (user?.userType === 'portal-admin') {
      return {
        serviceName: 'Portal System Admin',
        serviceHref: '/admin',
        tabs: getAdminTabs(tAdmin),
      };
    }
    return null;
  }
  return null;
}

export { getAdminTabs } from './admin';
export { tenantAdminTabs, getTenantAdminTabs } from './tenant-admin';
export { itServiceTabs } from './it-service';
export { getEntryTabs } from './entry';
